/**
 * @description Index
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module index
 */

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

const minimumBrowserSupport = {
        Chrome: process.env.SUPPORTED_VERSION_CHROME,
        Chromium: process.env.SUPPORTED_VERSION_CHROMIUM,
        Edge: process.env.SUPPORTED_VERSION_EDGE,
        Firefox: process.env.SUPPORTED_VERSION_FIREFOX
    },
    browserVersion = getBrowserVersion(),
    isSupported =
        minimumBrowserSupport[browserVersion.browser] &&
        browserVersion.version >= minimumBrowserSupport[browserVersion.browser];

ReactDOM.render(
    <App browserSupported={isSupported} supportedBrowserVersions={minimumBrowserSupport} />,
    document.getElementById('root')
);

/**
 * @description Gets the browser name and version.
 * @returns An object with the browser name and version.
 */
function getBrowserVersion() {
    const ua = window.navigator.userAgent,
        browserVersion = {
            browser: null,
            version: null
        },
        chromeVersionIndex = ua.indexOf('Chrome'),
        chromiumVersionIndex = ua.indexOf('Chromium'),
        edgeVersionIndex = ua.indexOf('Edge/'),
        firefoxVersionIndex = ua.indexOf('Firefox');

    if (chromiumVersionIndex !== -1) {
        browserVersion.browser = 'Chromium';
        browserVersion.version = parseInt(ua.substring(chromiumVersionIndex + 9).split('.')[0], 10);
    } else if (chromeVersionIndex !== -1 && edgeVersionIndex === -1) {
        browserVersion.browser = 'Chrome';
        browserVersion.version = parseInt(ua.substring(chromeVersionIndex + 7).split('.')[0], 10);
    } else if (edgeVersionIndex !== -1) {
        browserVersion.browser = 'Edge';
        browserVersion.version = parseInt(ua.substring(edgeVersionIndex + 5).split('.')[0], 10);
    } else if (firefoxVersionIndex !== -1) {
        browserVersion.browser = 'Firefox';
        browserVersion.version = parseInt(ua.substring(firefoxVersionIndex + 8).split('.')[0], 10);
    }

    return browserVersion;
}
